export var BREAKPOINTS = {
  xsOnly: '(max-width: 575px)',
  smOnly: '(min-width: 576px) and (max-width: 767px)',
  mdOnly: '(min-width: 768px) and (max-width: 991px)',
  lgOnly: '(min-width: 992px) and (max-width: 1199px)',
  xlOnly: '(min-width: 1200px)',
  smUp: '(min-width: 576px)',
  mdUp: '(min-width: 768px)',
  lgUp: '(min-width: 992px)',
  xlUp: '(min-width: 1200px)',
  xsDown: '(max-width: 575px)',
  smDown: '(max-width: 767px)',
  mdDown: '(max-width: 991px)',
  lgDown: '(max-width: 1199px)'
};


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/Constants.js
// module id = 770
// module chunks = 4